import zDialogo from '@/components/zDialogo.vue';
import zDialogoSimNao from '@/components/zDialogoSimNao.vue';
import zDialogoPergunta from '@/components/zDialogoPergunta.vue';

import zCampoValor from '@/components/zforms/zCampoValor.vue';
import zDatePicker from '@/components/zforms/zDatePicker.vue';
import zDateRangePicker from '@/components/zforms/zDateRangePicker.vue';
import zDatePickerMenu from '@/components/zforms/zDatePickerMenu.vue';
import zTimePicker from '@/components/zforms/zTimePicker.vue';
import zCpfCnpj from '@/components/zforms/zCpfCnpj.vue';
import zCep from '@/components/zforms/zCep.vue';
import zDateNavigation from '@/components/zforms/zDateNavigation.vue';
import zCampoTexto from '@/components/zforms/zCampoTexto.vue';
import zTextField from '@/components/zforms/zTextField.vue';
import zBusca from '@/components/zforms/zBusca.vue';
import zTextFieldSearch from '@/components/zforms/zTextFieldSearch.vue';
import zSelect from '@/components/zforms/zSelect.vue';
import zTextarea from '@/components/zforms/zTextarea.vue';
import zAutocomplete from '@/components/zforms/zAutocomplete.vue';
import zMenuButton from "@/components/zMenuButton.vue";
import zDialogoImpressao from "@/components/zDialogoImpressao.vue";

import zContainer from '@/components/zContainer.vue';
import zCentralizedToolbar from '@/components/zCentralizedToolbar.vue';
import zScrollLayout from '@/components/zScrollLayout.vue';
import zMensagem from '@/components/zMensagem.vue';
import zLoading from '@/components/zLoading.vue';
import zAguardar from '@/components/notifications/zAguardar.vue';
// import zToolbarDynamicMenu from '@/components/zToolbarDynamicMenu.vue';
import zTituloTela from '@/components/base/zTituloTela.vue';
import zCabecalho from '@/components/base/zCabecalho.vue';
import zFiltroAlfabetico from '@/components/base/zFiltroAlfabetico.vue';

import zNotificacao from '@/components/zNotificacao.vue';
import zAlerta from '@/components/zAlerta.vue';

import zCampoBuscarCliente from "@/components/zCampoBuscarCliente.vue";
import zBuscarCliente from "@/components/zBuscarCliente.vue";
import zSplitter from "@/components/zSplitter.vue";
import zTextFieldText from "@/components/zforms/zTextFieldText.vue";
import zDialogo2 from '@/components/zDialogo2'
import zDev from '@/components/zDev.vue';
import zStatusNfse from '@/components/zStatusNfse.vue';
import zTableItems from '@/components/zTableItems.vue';


export default {
  install: function (app) {

    app.component('zDialogo', zDialogo);
    app.component('zDialogoSimNao', zDialogoSimNao);
    app.component('zDialogoPergunta', zDialogoPergunta);

    app.component('zCampoValor', zCampoValor);
    app.component('zDatePicker', zDatePicker);
    app.component('zDateRangePicker', zDateRangePicker);
    app.component('zDatePickerMenu', zDatePickerMenu);
    app.component('zTimePicker', zTimePicker);
    app.component('zCpfCnpj', zCpfCnpj);
    app.component('zCep', zCep);
    app.component('zDateNavigation', zDateNavigation);
    app.component('zCampoTexto', zCampoTexto);
    app.component('zTextField', zTextField);
    app.component('zBusca', zBusca);
    app.component('zTextFieldSearch', zTextFieldSearch);
    app.component('zSelect', zSelect);
    app.component('zTextarea', zTextarea);
    app.component('zAutocomplete', zAutocomplete);
    app.component('zMenuButton', zMenuButton);
    app.component("zDialogoImpressao", zDialogoImpressao);

    app.component('zContainer', zContainer);
    app.component('zCentralizedToolbar', zCentralizedToolbar);
    app.component('zScrollLayout', zScrollLayout);
    app.component('zMensagem', zMensagem);
    app.component('zLoading', zLoading);
    app.component('zAguardar', zAguardar);
    // // app.component('zToolbarDynamicMenu', zToolbarDynamicMenu);
    app.component('zTituloTela', zTituloTela);
    app.component('zCabecalho', zCabecalho);
    app.component('zFiltroAlfabetico', zFiltroAlfabetico);

    app.component('zNotificacao', zNotificacao);
    app.component('zAlerta', zAlerta);

    app.component('zCampoBuscarCliente', zCampoBuscarCliente);
    app.component('zBuscarCliente', zBuscarCliente);
    app.component('zSplitter', zSplitter);
    app.component('zTextFieldText', zTextFieldText);
    app.component('zDialogo2', zDialogo2);

    app.component('zDev', zDev);
    app.component('zStatusNfse', zStatusNfse);
    app.component('zTableItems', zTableItems);
  }
}
